import { createContext, useState, useContext, useEffect } from 'react'
import { ReplaySessionContext } from './ReplaySessionContext'

export const ReplayChatContext = createContext()

export const ReplayChatProvider = ({ children }) => {
  const { session } = useContext(ReplaySessionContext)

  const [messages, setMessages] = useState([])
  const [currentInput, setCurrentInput] = useState("") 
  const [isAiProcessing, setIsAiProcessing] = useState(false)
  const [chatMeta, setChatMeta] = useState({
    currentUserId: 'USER',      
    currentUserName: "User",
    aiId: 'AI_AGENT'
  })
  
  return (
    <ReplayChatContext.Provider value={{
      messages,
      setMessages,
      currentInput,
      setCurrentInput,
      isAiProcessing,
      setIsAiProcessing,
      chatMeta,
      setChatMeta
    }}>
      {children}
    </ReplayChatContext.Provider>
  )
}